import { makeStyles } from "@material-ui/core/styles"

import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import SearchIcon from "@material-ui/icons/Search"

import AdminFullSizeCell from "./AdminFullSizeCell"

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: theme.typography.pxToRem(50)
    }
}))

export const AdminEmptyMessage = props => {
    const classes = useStyles()
    const { title, children } = props

    return (
        <AdminFullSizeCell>
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
            >
                <SearchIcon color="disabled" className={classes.icon} />
                <div>
                    <Typography align="center" variant="h6">
                        {title}
                    </Typography>
                    <Typography component="div" align="center" variant="body1">
                        {children}
                    </Typography>
                </div>
            </Box>
        </AdminFullSizeCell>
    )
}

export default AdminEmptyMessage
